<div class="tooltip-container">
  <span class="material-symbols-outlined">{{ iconName }}</span>
  <div
    #tooltipContent
    class="tooltip-content"
    [ngClass]="{ hidden: !isTooltipVisible, 'is-mobile-view': isMobileView }"
    [ngStyle]="tooltipPosition"
  >
    {{ translatedTooltipText }}
  </div>
</div>
